import { Navigate } from "react-router-dom"
import ManagementCompaniesTable from "../../components/tables/ManagementCompaniesTable"
import { usePublicSiteId } from "../../contexts/PublicSiteContext"
import { isConstructionWalk } from "../../utils/publicSite"
import CompaniesPage from "../companies"
import AddManagementCompany from "../addManagementCompany"

export default function ManagementCompaniesPage() {
  const siteId = usePublicSiteId()
  return isConstructionWalk(siteId) ? <CompaniesPage /> : <ManagementCompaniesTable />
}

/** ConstructionWalk add-company is a modal, not the old logo/phone form. */
export function ManagementCompanyFormRoute() {
  const siteId = usePublicSiteId()
  if (isConstructionWalk(siteId)) {
    return <Navigate to="/app/management-companies" replace />
  }
  return <AddManagementCompany />
}
